// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { IssueTypeId, ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { IssueType, State } from '../types.tsx';

type IssueTypeWithProjectId = IssueType & {
	projectId: ProjectId;
};

export const populateIssueTypes =
	({ issueTypes }: { issueTypes: IssueTypeWithProjectId[] }) =>
	async ({ setState }: StoreActionApi<State>) => {
		const issueTypesById: Record<IssueTypeId, IssueTypeWithProjectId> = {};
		const issueTypesByProjectId: Record<ProjectId, IssueTypeId[]> = {};

		issueTypes.forEach((issueType) => {
			issueTypesById[issueType.id] = issueType;

			if (!issueTypesByProjectId[issueType.projectId]) {
				issueTypesByProjectId[issueType.projectId] = [];
			}
			issueTypesByProjectId[issueType.projectId].push(issueType.id);
		});

		setState({
			issueTypesById,
			issueTypesByProjectId,
		});
	};
